<template>
  <div class="top-base" :class="{'has-notification': hasNotification }">
    <div class="top-info"><p class="top-info-title">【重要】サービス終了のお知らせ</p>  
      <p>平素ご愛顧いただき、誠にありがとうございます。<br>占いTVは、2023年5月31日をもちましてサービスを終了いたします。</p> 
      <a class="top-button" href="/announcement"><p>詳細</p></a>
    </div>
    <div class="banner-wrap">
      <!-- NEWRelease -->
      <p class="banner-subtitle">【PR】2023年4月<br>姉妹サイトオープン</p>
      <a href="https://kurenotori.jp?utm_source=uranai.tv&utm_medium=referral&utm_campaign=LO00100004"><img class="banner-yearluck-2023 maru" src="/static/img/banner/kurenotori_2.jpg"></a>
    </div>
    <!-- <slider-banner v-if="sliderBannerList.length > 0" :info-banner="sliderBannerList" /> -->
    <hero-slider
      v-if="sliderBannerList.length > 0"
      :info-banner="sliderBannerList"
      :bottom-slider="heroBottomSliderList"
    />

    <section
      class="content-section"
      v-for="(sec, secidx) in featuresList"
      :key="`sec${secidx}`"
      :class="{[sec.className]:true}"
    >

      <h2 v-if="sec.titleArr">
        <span class="subtitle" v-if="sec.titleArr[1]" v-html="sec.titleArr[1]"></span>
        <span class="title" v-html="sec.titleArr[0]"></span>
      </h2>

      <!-- 特集リスト -->
      <div class="sec-inner" v-if="+sec.type === 0 || !sec.type">
        <div class="features-banner-wrap" v-if="!!sec.image && sec.image.length > 0">
          <a
            class="features-banner"
            :class="{'no-link': !sec.url}"
            :href="sec.url"
            @click.prevent="onBannerClick($event, sec)"
          ><img :src="sec.image" :alt="sec.title"></a>
        </div>
        <sec-features-list  :list-data="sec" />
      </div>

      <!-- バナー -->
      <div class="sec-inner" v-else-if="+sec.type === 2">
        <div class="features-banner-wrap">
          <a
            v-if="!!sec.image && sec.image.length > 0"
            class="features-banner"
            :class="{'no-link': !sec.url}"
            :href="sec.url"
            @click.prevent="onBannerClick($event, sec)"
          ><img :src="sec.image" :alt="sec.title"></a>
        </div>
      </div>

      <!-- リアムタロット -->
      <div class="sec-inner" v-else-if="+sec.type === 3">
        <daily-tarot :user-profile="userProfile"/>
      </div>

      <!-- Today's Lucky7 -->
      <div class="sec-inner" v-else-if="+sec.type === 4">
        <menus-section
          :idx-in-page="0"
          :section-data="sectionsData.todaysLucky7"
          @link-click="onLinkClick"
        ></menus-section>
      </div>

      <!-- 特集リスト(占い師) -->
      <div class="sec-inner" v-else-if="+sec.type === 5">
        <div class="features-banner-wrap">
          <div class=" counselor-list">
            <div class="list-wrap">
              <a
                class="counselor-item"
                v-for="(counselor, cidx) in sec.counselor"
                :href="counselor.url"
                :key="`c${cidx}`"
                @click.prevent="onBannerClick($event, counselor)"
              ><img :src="counselor.thumb" alt=""></a>
            </div>
          </div>
        </div>
        <sec-features-list :list-data="sec" />
      </div>

      <!-- バナーグループ(トップは原則入会特典のみの特殊処理になるので注意) -->
      <div class="sec-inner" v-else-if="+sec.type === 7">
        <div class="features-banner-wrap">
          <a
            class="features-banner"
            v-for="(bn, bnidx) in sec.items"
            :class="{'no-link': !sec.url}"
            :href="bn.url"
            :key="`sec${secidx}_${bnidx}`"
            @click.prevent="onBannerClick($event, bn)"
          ><img :src="bn.thumb" :alt="bn.title"></a>
        </div>
      </div>


    </section>


    <member-tutorial v-if="tutorialShow" @tuto-close="onCloseTutorial" />

  </div>
</template>

<script>
import moment from 'moment'
import {MENU_SEC_TYPES, SEC_ICON_TYPE, FEATURES_SEC_TYPES} from '@/CONSTS/MENUS'
import {FORTUNE_INFO} from '@/CONSTS/FORTUNE_INFO'
import HotTagList from '@/utvStore/components/Toppage/section/HotTagList'
import SliderBanner from '@/utvStore/components/partials/SliderBanner'
import InfoBanner from '@/utvStore/components/partials/InfoBanner'
import DailyTarot from '@/utvStore/components/Toppage/section/DailyTarot'
import Notifications from '@/utvStore/components/partials/Notifications'
import MenusSection from '@/utvStore/components/partials/MenusSection'
import SecButtonLink from '@/utvStore/components/partials/SecButtonLink'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import NewArrivalMenus from '@/utvStore/components/Toppage/section/NewArrivalMenus'
import DeluxeBanner from '@/utvStore/components/Toppage/section/DeluxeBanner'
import * as type from '@/utvStore/store/mutation-types'
import {mapState} from 'vuex'
import MemberTutorial from '@/utvStore/components/Toppage/MemberTutorial'
const TUTO_COOKIE_KEY = 'tutorial_already_showed'
import HeroSlider from './section/HeroSlider'
import SecFeaturesList from "./section/SecFeaturesList";

export default {
  name: 'MemberTop2023Contents',
  components: {
    SecFeaturesList,
    HeroSlider,
    NewArrivalMenus,
    MemberTutorial,
    FixedBackground,
    SecButtonLink,
    MenusSection,
    HotTagList,
    Notifications,
    DailyTarot,
    SliderBanner,
    InfoBanner,
    DeluxeBanner,
  },
  data() {
    return {
      sectionsData: {},
      videoSendSrc: {},
      tutorialShow: false,
      // hasNotification: false,
      openNotification: false
    }
  },
  props: {
    receiveSectionsData: {
      type: Object,
      default() {
        return {}
      }
    },
    receivedFeaturesList: {
      type: Array,
      default() {
        return []
      },
    },
    linkbtnData: {
      type: Array,
      default() {
        return []
      }
    },
    hotTaglist: {
      type: Array,
      default() {
        return []
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    sliderBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    infoBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    isSubscrEnable: {
      type: Boolean,
      require: true,
    },
    hasNotification: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      subscriptVideoData: states => states.item.subscrItems
    }),
    heroBottomSliderList() {
      const tgt = this.receivedFeaturesList.filter(item => +item.type === 1)
      return !!tgt && tgt.length > 0 && tgt[0].items ? tgt[0].items : null
    },
    featuresList() {
      return this.receivedFeaturesList
        .filter(item => +item.type !== 1)
        .map(item => {
          const arr = []
          if(!!item.title && item.title.length > 0) {
            if(typeof item.title === 'string') {
              arr.push(item.title)
            } else {
              arr.push(...item.title)
            }
          }
          return {
            ...item,
            className: FEATURES_SEC_TYPES[+item.type].class_name,
            titleArr: arr.length > 0 ? arr : null,
          }
        })
    },
  },
  watch: {
    subscriptVideoData: {
      handler() {
      },
      deep: true
    },
  },
  created() {
    //チュートリアルクッキーチェック
    this.checkTutorial()
  },
  mounted() {
    // console.log('featuresList received:[%O] processed:[%O] herobottom[%O]', this.receivedFeaturesList, this.featuresList, this.heroBottomSliderList)
    this.setSectionsData(this.receiveSectionsData)
  },
  methods: {
    checkTutorial(){
      const ck = document.cookie
      const regex = new RegExp(`${TUTO_COOKIE_KEY}=(\\d+)`)
      const checkArr = ck.match(regex)
      if(this.userProfile && this.userProfile.subscription){
        const subsc = this.userProfile.subscription
        if((!checkArr || (!!checkArr && !!checkArr[1] && parseInt(checkArr[1]) < 1 ))
          && parseInt(subsc.active) === 1
          && parseInt(subsc.status) === 0
        ){
          this.tutorialShow = true //タイマー等で時間差をつけてもらっても
        }
      }
    },
    onCloseTutorial(){
      this.tutorialShow = false
      this.setTutorialCookie()
    },
    setTutorialCookie(){
      setTimeout(()=>{
        document.cookie = `${TUTO_COOKIE_KEY}=${parseInt(Math.random() * 10000000) + 1}; max-age=${60 * 60 * 24 * 3650}`
      },0)
    },
    setSectionsData: function (rcv) {
      if (rcv != null) {
        this.sectionsData = {}

        //並び順はベタで書く
        // <<< Today’s Lucky 7 >>>
        if (rcv.todaysLucky7 != null) {
          const tgt = rcv.todaysLucky7
          this.sectionsData['todaysLucky7'] = {
            label: 'Today’s Lucky 7',
            tagId: tgt.tagId,
            coloredBg: true,
            type: MENU_SEC_TYPES.todays_lucky7,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['todaysLucky7'].items)
        }

        // <<< 今日のピックアップ >>>
        if (rcv.todaysPickup != null) {
          const tgt = rcv.todaysPickup
          this.sectionsData['todaysPickup'] = {
            label: tgt.label,
            tagId: tgt.tagId,
            subtitle: '今日のピックアップ',
            type: MENU_SEC_TYPES.def_movie,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['todaysPickup'].items)
        }

        // <<< 今年の運勢 >>>
        if (rcv.yearLuck != null) {
          const tgt = rcv.yearLuck
          this.sectionsData['yearLuck'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            subtitle: '1年間の運勢をチェック！',
            type: MENU_SEC_TYPES.def_text,
            itemLimit: 3,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['yearLuck'].items)
        }

        // <<< 今週ピックアップ テキスト >>>
        if (rcv.weeklyPickupText != null) {
          const tgt = rcv.weeklyPickupText
          this.sectionsData['weeklyPickupText'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            subtitle: '今週のピックアップ',
            type: MENU_SEC_TYPES.def_text,
            itemLimit: 3,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['weeklyPickupText'].items)
        }

        // <<< 今週のピックアップ 動画 >>>
        if (rcv.weeklyPickupMovie != null) {
          const tgt = rcv.weeklyPickupMovie
          this.sectionsData['weeklyPickupMovie'] = {
            label: tgt.label,
            tagId: tgt.tagId,
            type: MENU_SEC_TYPES.def_movie,
            iconType: SEC_ICON_TYPE.movie,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['weeklyPickupMovie'].items)
        }

        // <<< ピックアップ占い師 >>>
        if (rcv.pickupCounselor != null) {
          const tgt = rcv.pickupCounselor
          this.sectionsData['pickupCounselor'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            type: MENU_SEC_TYPES.counselor,
            subtitle: '注目の占い師',
            iconType: SEC_ICON_TYPE.text,
            categoryLink: `/tag/${tgt.tagId}`,
            items: [{
              label: tgt.label,
              menuId: parseInt(tgt.tagId),
              description: tgt.description,
              thumbnail: tgt.thumbnail,
              isRight: false,
              hasMovieLink: false,
            }]
          }
          this.checkMovieContents(this.sectionsData['pickupCounselor'].items)
        }

        // <<< ピックアップ占術 >>>
        if (rcv.pickupFortune != null) {
          const tgt = rcv.pickupFortune
          const info = FORTUNE_INFO[`id${tgt.tagId}`]
          this.sectionsData['pickupFortune'] = {
            label: `#${tgt.label}`, //←これここで#つけてだいじょうぶか？
            tagId: parseInt(tgt.tagId),
            type: MENU_SEC_TYPES.fortune,
            iconType: SEC_ICON_TYPE.text,
            categoryLink: `/tag/${tgt.tagId}`,
            items: [{
              label: tgt.label,
              menuId: parseInt(tgt.tagId),
              description: info != null ? info.description || '' : '',
              thumbnail: info != null ? info.thumbnail || '' : '',
              isRight: true,
              hasMovieLink: +rcv.pickupFortune.hasMovieLink > 0,
            }]
          }
          this.checkMovieContents(this.sectionsData['pickupFortune'].items)
        }

        // <<< 新着メニュー >>>
        if (rcv.newMenu != null) {
          const rtn = []

          for(let key in rcv.newMenu){
            rtn.push({
              ...rcv.newMenu[key],
            })
          }

          rtn.sort((a, b)=>{
            const aDate = new moment(a.openedAt)
            const bDate = new moment(b.openedAt)
            if( aDate.isBefore(bDate) ) return 1;
            if( aDate.isAfter(bDate) ) return -1;
            return 0;
          })
          this.sectionsData['newMenu'] = rtn
        }

        // <<< タグアイテム群 >>>
        if (rcv.__tagItems != null) {
          if (this.sectionsData['__tagItems'] != null) {
            this.sectionsData['__tagItems'].splice(0)
          } else {
            this.sectionsData['__tagItems'] = []
          }
          const tgtlist = this.sectionsData['__tagItems']
          for (let [index, tgt] of rcv.__tagItems.entries()) {
            const ltype = tgt.listType != null ? parseInt(tgt.listType) : 1
            const len = tgtlist.push({
              label: `#${tgt.label}`, //←これここで#つけてだいじょうぶか？
              tagId: parseInt(tgt.tagId),
              isTagItem: true,
              type: ltype === 2 ? MENU_SEC_TYPES.def_movie : MENU_SEC_TYPES.def_text, // 1以外はテキスト
              iconType: ltype === 2 ? SEC_ICON_TYPE.movie : SEC_ICON_TYPE.text, // 1以外はテキスト
              items: [...tgt.items]
            })
            this.checkMovieContents(tgtlist[len - 1].items)
          }
        }
        //console.log('sectionsData: %O  videoSendSrc: %O', this.sectionsData, this.videoSendSrc)
        this.setMovieData()
      }
    },
    setMovieData() {
      //console.log('動画データセット: %O', this.videoSendSrc)
      if(Object.keys(this.videoSendSrc).length > 0) {
        this.$store.dispatch(type.GET_SUBSCRIPT_VIDEO, this.videoSendSrc)
      }
    },
    checkMovieContents(itemList = []) {
      if (itemList.length > 0) {
        for (let item of itemList) {
          if ('videoId' in item && JSON.stringify(item.videoId) !== 'null') {
            this.videoSendSrc[`id${item.videoId}`] = item.videoId
          }
        }
      }
    },
    onLinkClick(url){
      if( url != null && !!this.userProfile && this.userProfile.subscription ){
        const subsc = this.userProfile.subscription
        if( subsc.status === 2) {
          location.href = '/error/suspension'
        }else{
          location.href = url
        }
      }else{
        console.error('ページ遷移ができません')
      }
    },
    onBannerClick(e, data) {
      location.href = data.url
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.top-base {
  width: 100%;
  padding-bottom: 60px;
  background: url(/static/img/toppage/bg_mtop_pink1.png) repeat top left;
  background-size: 60%;
  &.has-notification {
    padding-top: 34px;
  }
  &__banner {
    padding: 10px 20px 5px;
    img {
      max-width: 100%;
      vertical-align: middle;
      box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
      border-radius: unquote("min(2.667vw, 15.5px)");
    }
  }

  // 以下 MTOP改修202212
  .hero-slider {
    margin-bottom: 16px;
  }

  .top-info{
    background: #fff;
    text-align: center;
    padding: 20px;
  }
  .top-info-title{
    font-weight: bold;
  }

  .top-button{
    display: block;
    background: #d0e1ff;
    text-decoration: none;
    p{
      padding: 10px;
    }
  }
  // TODO: マージンの取り方がおかしいので調整 -> ブロックごとに成立するように
  .content-section {
    width: 100%;
    margin: 0 0 24px;
    h2 {
      color: #907d4c;
      text-align: left;
      padding: 0 20px;
      margin: 0 0 8px;
      .title {
        @extend .source-han-serif-bold;
        font-size: 18px;
        display: block;
      }
      .subtitle {
        @extend .source-han-sans-bold;
        display: block;
        font-size: 13px;
        line-height: 1;
      }
    }
    .sec-inner {
      width: 100%;
      .sec-lucky7 {
        padding-top: 0;
      }
      .features-banner-wrap {
        width: 100%;
        padding: 0 24px;
        margin-bottom: 20px;
        .features-banner {
          width: 100%;
          display: block;
          cursor: pointer;
          user-select: none;
          &.no-link {
            pointer-events: none;
          }
          img {
            width: 100%;
            display: block;
            user-select: none;
          }
        }
        .counselor-list {
          width: 100%;
          background: white;
          padding: 16px;
          border-radius: 10px;
          .list-wrap {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .counselor-item {
              width: 25%;
              display: block;
              cursor: pointer;
              user-select: none;
              flex-shrink: 1;
              margin-right: 8px;

              &:last-child {
                margin-right: 0;
              }

              img {
                width: 100%;
                display: block;
                user-select: none;
              }
            }
          }
        }
      }
    }

    &.banner-group {
      background: #ffddec;
      padding: 16px 20px 20px;
      h2 {
        display: flex;
        flex-direction: row-reverse;
        justify-content: left;
        align-items: center;
        padding: 0;
        .subtitle {
          display: inline-block;
          background: white;
          border-radius: 9999px;
          margin-left: 8px;
          padding: 2px 8px;
          font-size: 12px;
        }
      }
      .sec-inner {
        .features-banner-wrap {
          padding: 0;
          margin: 0;
          .features-banner {
            margin-bottom: 8px;
            filter: drop-shadow(4px 4px 4px rgba(0,0,0, 0.1));
            pointer-events: auto;
            img {
              pointer-events: none;
            }
          }
        }
      }
    }

  }

  .banner-wrap {
      width: 100%;
      padding: 8px 20px 20px;
      a {
        display: block;
        img {
          display: block;
          width: 100%;
          box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.1);
        }
      }
  }
  .maru{
    border-radius: 12px;
  }
  .banner-subtitle{
    text-align: center;
    margin-bottom: 4px;
    font-size: 17px;
    color: #000;
    @include mq('w580') {
      font-size: 23px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/MemberTop2023Contents.vue